import React from 'react';
import CustomTabs from '../common/CustomTabs';
import PageHeader from '../common/PageHeader';
import AssignmentViewUpdate from './AssignmentViewUpdate';
import GridTable from '../common/Table/Table';
import { UpdateColumnWithConfiguration } from '../../utils/helper';
import { propertyallocationConfig, propertyColumnsPTF } from '../../constants/MockData';
import { apiBatchRequest } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import { API_URL } from '../../constants/api';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
class AssignmentInfo extends React.PureComponent {
  // Constructor to define initial state of the component
  constructor (props) {
    super(props);
    this.state = {
      MarketDetails: undefined,
      PropertyData: undefined,
      configuration: undefined,
      propertyDetails: [],
      propertyColumnsPTFList: propertyColumnsPTF.filter(x => x.name !== 'Action')

    };
  }

  // Get data from APIs before component is mounted
  componentDidMount () {
    this.getData();
  }

  // Get APIs data 
  getData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url:
        API_URL.Property.GetPropertyData +
        '?propertyId=' +
        (this.props.selectedAssignmentPropertyId || -1),
        key: 'propertyData'
      }
    ])
      .then(({
        propertyData
      }) => {
        if (propertyData.success === true) {
          this.setState({
            propertyData: propertyData.data || [],
            configuration: propertyData.config || []
          });
        } else {
          ShowToast('', toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast('', toastType.ERROR, 5000, 500, 'Server error');
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Navigate to main page
  goBack = () => {
    this.props.onBack();
  }

  // Render components based on conditions
  render () {
    const Tabs = [
      {
        name: 'Assignment Details',
        id: 1,
        childComponent: (
          <AssignmentViewUpdate
            goBack={this.goBack}
            selectedAssignmentID={this.props.selectedAssignment}
            assignmentData={this.props.assignmentData}
            propertyMasterData={this.props.propertyMasterData}
            serviceTypeMasterData={this.props.serviceTypeMasterData}
            marketMasterData={this.props.marketMasterData}
            viewTitle={this.props.ViewTitle}
            actionType={this.props.actionType}
          />
        )
      },
      {
        name: 'Assignment Property',
        id: 2,
        childComponent:
        <GridTable
            key={'propertyDetailsTable'}
            columns={UpdateColumnWithConfiguration(
              this.state.propertyColumnsPTFList,
              this.state.configuration
            )}
            config={propertyallocationConfig}
            data={this.state.propertyData}
            renderActionColumn={
                 () => {
                   return <></>;
                 }
            }
          ></GridTable>
      }
    ];

    return (
      <>
        <div className="col-sm-12 col-lg-12">
          <PageHeader
            title={'Assignment Details '} //+ '(' + this.props.ViewTitle + ')'}
            actionsConfig={[
              {
                icon: <ArrowBackIcon size="small" className="back-button" />,
                onClick: this.props.onBackClick,
                title: 'Back to Assignments'
              }
            ]}
          ></PageHeader>
        </div>

        <div className="row Row_flex bottom-lg">
          <CustomTabs tabsList={Tabs} currentSelectedTab={1} />
        </div>
      </>
    );
  }
}

export default AssignmentInfo;
